class Popin {
    static init() {
        this.html = document.querySelector("html");
        this.ctaPopin = document.querySelectorAll(".openPopin");
        this.ctaPopin.forEach(cta => {
            cta.popin = cta.parentElement.querySelector(".popin");

            if (cta.popin) {
                cta.close = cta.popin.querySelector(".popin__close");

                cta.addEventListener("click", () => {
                    cta.popin.classList.add("popin--visible");
                    this.html.classList.add("html--noscroll");
                });

                if (cta.close) {
                    cta.close.addEventListener("click", () => {
                        cta.popin.classList.remove("popin--visible");
                        this.html.classList.remove("html--noscroll");
                    });
                }
            }
        })
    }
}
export default Popin;


// WEBPACK FOOTER //
// ./src/scripts/components/popin.js